import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@shared-services/auth.service';
import { getTvReturnUrl, tvReturnQueryParams } from '../auth/tv-return-url';
import { TvEntryContext } from '../auth/tv-entry-context';

export const alreadyAuthGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (inject(TvEntryContext).resolve(state.url ?? '/iniciar-sesion', route.queryParams?.['returnUrl']) === 'ENTRY') return router.createUrlTree(['/tv']);

  if (!auth.isAuthenticated()) return true;

  const returnUrl = getTvReturnUrl(route.queryParams?.['returnUrl']);
  const nextRoute = auth.requiresPasswordChange()
    ? '/cambiar-contrasena-obligatoria'
    : auth.requiresLegalConsent()
      ? '/consentimiento-legal'
      : returnUrl ?? '/';
  const queryParams = tvReturnQueryParams(returnUrl);
  return router.createUrlTree([nextRoute], queryParams && nextRoute !== returnUrl ? { queryParams } : undefined);
};
